import {
  GET_SUPPORTED_DOCUMENTS_REQUEST,
  GET_SUPPORTED_DOCUMENTS_SUCCESS,
  GET_SUPPORTED_DOCUMENTS_FAILURE,
  GET_CLIENT_SUPPORTED_DOCUMENTS_REQUEST,
  GET_CLIENT_SUPPORTED_DOCUMENTS_SUCCESS,
  GET_CLIENT_SUPPORTED_DOCUMENTS_FAILURE,
  GET_GENERIC_TYPE_DOCUMENTS_REQUEST,
  GET_GENERIC_TYPE_DOCUMENTS_SUCCESS,
  GET_GENERIC_TYPE_DOCUMENTS_FAILURE,
} from '../actions/supported_documents'

export const fetchSupportedDocuments = (
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
    count: 0,
    nextUrl: null,
  },
  action
) => {
  switch (action.type) {
    case GET_SUPPORTED_DOCUMENTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case GET_SUPPORTED_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response.results,
        count: action.response.count,
        nextUrl: action.response.next,
        errorMessage: null,
      }
    case GET_SUPPORTED_DOCUMENTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const fetchClientSupportedDocuments = (
  state = {
    isFetching: false,
    response: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_CLIENT_SUPPORTED_DOCUMENTS_REQUEST:
      return {
        ...state,
        response: [],
        isFetching: true,
        errorMessage: null,
      }
    case GET_CLIENT_SUPPORTED_DOCUMENTS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        response: action.response,
      }
    case GET_CLIENT_SUPPORTED_DOCUMENTS_FAILURE:
      return {
        ...state,
        errors: null,
        response: [],
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const fetchGenericTypeDocuments = (
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
    count: 0,
    nextUrl: null,
  },
  action
) => {
  switch (action.type) {
    case GET_GENERIC_TYPE_DOCUMENTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case GET_GENERIC_TYPE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response.results,
        count: action.response.count,
        nextUrl: action.response.next,
        errorMessage: null,
      }
    case GET_GENERIC_TYPE_DOCUMENTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
